<template>
  <div>
    <v-tabs v-model="tab" class="primary-background">
      <v-tab v-for="item in tabItems" :key="item.name">
        {{ item.name }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item v-for="item in tabItems" :key="item.name">
        <v-card v-if="item.name === 'Usage'" flat>
          <AdminAtlasUsage />
        </v-card>
        <v-card v-if="item.name === 'Workflows'" flat>
          <AdminAtlasWorkflows />
        </v-card>
        <v-card v-if="item.name === 'Settings'" flat>
          <!-- Same client-settings editor as Admin -> Settings, scoped to
               the Atlas category. Saves via admin/settings (admin page
               permission), so this tab needs the caller to be a full
               admin — which everyone granted atlasadmin currently is. -->
          <SettingsAdmin category="Atlas" />
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import AdminAtlasWorkflows from './cAdminAtlasWorkflows.vue';
import AdminAtlasUsage from './cAdminAtlasUsage.vue';
import SettingsAdmin from './cAdminSettings.vue';

export default {
  name: 'adminAtlasHolder',
  data: function () {
    return {
      tab: 0,
    };
  },
  components: {
    AdminAtlasWorkflows,
    AdminAtlasUsage,
    SettingsAdmin,
  },
  computed: {
    tabItems() {
      return [
        { name: 'Usage', text: '' },
        { name: 'Workflows', text: '' },
        { name: 'Settings', text: '' },
      ];
    },
  },
};
</script>
